<template>
    <div>
        <RouterLink :to="{ name: 'home' }" class="flex items-center w-full lg:w-auto">
            <img
                class="cursor-pointer mr-4"
                src="@/assets/images/iiportal-administracija-logo.svg"
                alt="logo"
                :class="[small ? 'max-h-[1.8rem]' : 'max-h-[2.7rem] lg:max-h-[3.5rem]']"
            >
        </RouterLink>
    </div>
</template>

<script lang="ts" setup>
    defineProps({
        small: {
            type: Boolean,
            default: false
        }
    })
</script>
